var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.loading)?_c('tbody',[_vm._t("default")],2):_c('tbody',{staticClass:"container-loading"},_vm._l((10),function(index){return _c('section',{key:index},[_c('GrSkeleton',{staticClass:"loading",attrs:{"sizeX":"100%","sizeY":"81px","radius":"10px","delay":index + 2}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }